import type { VAxios } from '../../define/axios/Axios';

/**
 * 字体接口配置
 */
export const createApi = (defHttp: VAxios) => ({
  list: (params) => {
    return defHttp.get({ url: `/aiad/fonts`, params });
  },
  create: (params) => {
    return defHttp.post({ url: `/aiad/fonts`, params });
  },
  delete: (id) => {
    return defHttp.delete({ url: `/aiad/fonts/${id}` });
  },
});
